import { DeepLink } from '@/models';
import { apiClient, signedApiClient } from './apiClient';


class DeepLinkService {

  BRANCH_URL: string = '';
  BRANCH_API_KEY: string = '';

  initService() {
    this.BRANCH_URL = import.meta.env.VITE_APP_BRANCH_URL;
    this.BRANCH_API_KEY = import.meta.env.VITE_APP_BRANCH_API_KEY;
  }

  /**
   * The Branch link an invite's or a study link's token names, from `study/:id/link/:linkId`, the
   * TypeScript name of the old `investigation` route. An expired invite answers 400 with its expiry
   * and the inviter's name (`ExpiredLinkBody`).
   */
  async getDeepLink(token: string, studyId?: string, groupId?: string) {
    let uri = '';
    if (studyId) {
      uri = `study/${studyId}/link/${token}`;
    } else if (groupId) {
      uri = `group/${groupId}/link/${token}`;
    }
    const signedClient = signedApiClient('GET', uri);
    const linkResponse = await signedClient.get(uri);
    return linkResponse.data;
  }

  async getDeepLinkData(link: string) {
    // Branch.io, not our backend. `signedApiClient` no longer writes credentials onto the shared
    // client's defaults, so there is nothing to strip before calling out.
    const uri = `${this.BRANCH_URL}/url?url=${link}&branch_key=${this.BRANCH_API_KEY}`;
    const res = await apiClient.get(uri);
    return DeepLink.mapLink(res.data.data);
  }
}

export default new DeepLinkService;
